import { AlertTriangle } from "lucide-react";

export function WarningCallout({ children, title = "Обратите внимание" }: { children: React.ReactNode; title?: string }) {
  return (
    <div className="warning-callout" role="note">
      <AlertTriangle size={20} aria-hidden="true" />
      <div>
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
    </div>
  );
}
